const HomePage = () => {
  return (
    <div>
      <h1 className="phonebookTitle">Phonebook</h1>
      <p>
        This application provides the ability to conveniently manage your
        contacts and have access to your phone book anywhere in the world.
      </p>
      <p>
        <b>Just try this!</b>
      </p>
    </div>
  );
};
export default HomePage;
